import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment/moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const addAssignUnit = createAsyncThunk('assign_unit/add', async (data) => {

    var documents = data?.values?.documents?.map((item) => (
        { documents_name: item?.name, documents_file: item?.file }
    ))

    var bodyFormData = new FormData()

    bodyFormData.append("premise_id", data?.values?.premise)
    bodyFormData.append("zone_id", data?.values?.zone)
    bodyFormData.append("level_id", data?.values?.level)
    bodyFormData.append("unit_id", data?.values?.unit)
    bodyFormData.append("user_id", data?.values?.user)
    bodyFormData.append("start_date", data?.values?.start_date && moment(data?.values?.start_date, 'DD/MM/YYYY').format('YYYY-MM-DD'))
    bodyFormData.append("occupancy_status", data?.values?.occupancy_status)
    bodyFormData.append("property_type", data?.values?.property_type)
    bodyFormData.append("is_household", data?.values?.is_household ?? false)
    bodyFormData.append("documents", JSON.stringify(documents))
    bodyFormData.append("terms_and_conditions", data?.values?.terms)
    bodyFormData.append("type", data?.values?.type)

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'unit_assignment',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "document", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateAssignUnit = createAsyncThunk('assign_unit/update', async (data) => {

    var documents = data?.values?.documents?.map((item) => (
        { id: item?.id, documents_name: item?.name, documents_file: item?.file }
    ))

    var bodyFormData = new FormData()

    bodyFormData.append("unit_assignment_id", data?.values?.id)
    bodyFormData.append("premise_id", data?.values?.premise)
    bodyFormData.append("zone_id", data?.values?.zone)
    bodyFormData.append("level_id", data?.values?.level)
    bodyFormData.append("unit_id", data?.values?.unit)
    bodyFormData.append("user_id", data?.values?.user)
    bodyFormData.append("start_date", data?.values?.start_date && moment(data?.values?.start_date, 'DD/MM/YYYY').format('YYYY-MM-DD'))
    bodyFormData.append("property_type", data?.values?.property_type)
    bodyFormData.append("is_household", data?.values?.is_household ?? false)
    bodyFormData.append("documents", JSON.stringify(documents))
    bodyFormData.append("terms_and_conditions", data?.values?.terms)
    bodyFormData.append("type", data?.values?.type)

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'update_unit_assignment',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "document", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateChargesPaidBy = createAsyncThunk('assign_unit/updateChargesPaidBy', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'unit_paid_status',
            data: {
                premise_id: data?.values?.premise_id,
                unit_id: data?.values?.unit_id,
                user_id: parseInt(data?.values?.user_id)
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const assignUnitDetails = createAsyncThunk('assign_unit/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `assign_unit_details/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const assignUnit = createSlice({
    name: 'assignUnit',
    initialState: {
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(assignUnitDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default assignUnit.reducer;